import { FunctionComponent, useContext, useState } from "react";
import PageTitle from "./page-title";
import UploadButton from "./upload-button";
import AssetsGrid from "./assets-grid";
import { AssetType } from "types/asset";
import Button from "components/button";
import { supabase } from "libs/supabase";
import { LoadingContext } from "providers/loading";
import { ADD_ASSET_BUTTON_TEST_ID, DELETE_SELECTED_BUTTON_TEST_ID } from "constants/test";

interface AssetsPageProps {
  assetType: AssetType;
}

const AssetsPage: FunctionComponent<AssetsPageProps> = ({ assetType }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedIds, setSelectedIds] = useState<(number | undefined)[]>([]);
  const { setLoading } = useContext(LoadingContext);

  const deleteSelected = async () => {
    setLoading(true);
    await supabase.from("assets").delete().in("id", selectedIds);
    setLoading(false);
    setRefreshKey((prev) => prev + 1);
    setSelectedIds([]);
  };

  return (
    <div className="p-9">
      <div className="flex items-center justify-between mb-9">
        <PageTitle className="capitalize">{assetType}s</PageTitle>
        <div className="flex">
          {!selectedIds.length ? null : (
            <Button
              data-testid={DELETE_SELECTED_BUTTON_TEST_ID}
              onClick={() => {
                if (window.confirm("Delete selected items?")) {
                  deleteSelected();
                }
              }}
              variant="secondary-red"
              className="px-7 mr-7"
            >
              Delete selected
            </Button>
          )}
          <UploadButton onCompletedUpload={() => setRefreshKey((prev) => prev + 1)} assetType={assetType} className="w-[160px]">
            Upload
          </UploadButton>
        </div>
      </div>
      <AssetsGrid key={refreshKey} assetType={assetType} selectedIds={selectedIds} setSelectedIds={setSelectedIds} />
    </div>
  );
};

export default AssetsPage;
